var _rect, _path, _path2, _path3, _rect2, _path4, _rect3, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgAutoLockout = function SvgAutoLockout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 45.098l17.94-20.931H67.5v45.351H24.64l-7.973-24.42z",
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.637 43.91L37.95 29.649h23.57v14.26H25.636z",
    fill: "#FFF9DC",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.549 50.082h6.977",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 55.833,
    width: 9.167,
    height: 23.333,
    rx: 4.583,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.643 55.238v-9.525l-1.31-2.341 1.31-2.341 1.31-2.341-1.31-2.341-1.31-2.341 1.31-2.341",
    stroke: "#332C4A",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.667,
    y: 56.667,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 1.667
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.167 69.792c-1.036 0-1.875.84-1.875 1.875v3.001a3.75 3.75 0 103.75 0v-3.001c0-1.036-.84-1.875-1.875-1.875z",
    fill: "#F8F8FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.292 74.668l.417.722.416-.24v-.482h-.833zm3.75 0h-.834v.481l.416.24.418-.72zm-2.917-3.001c0-.576.467-1.042 1.042-1.042v-1.667a2.708 2.708 0 00-2.709 2.709h1.667zm0 3.001v-3.001h-1.667v3.001h1.667zm-1.875 3.249c0-1.079.585-2.022 1.459-2.527l-.835-1.443a4.582 4.582 0 00-2.29 3.97h1.666zm2.917 2.916a2.917 2.917 0 01-2.917-2.916h-1.667a4.583 4.583 0 004.584 4.583v-1.667zm2.916-2.916a2.917 2.917 0 01-2.916 2.916V82.5a4.583 4.583 0 004.583-4.583h-1.667zm-1.459-2.527a2.915 2.915 0 011.46 2.527h1.666a4.582 4.582 0 00-2.291-3.97l-.835 1.443zm-.416-3.723v3.001h1.667v-3.001h-1.667zm-1.041-1.042c.575 0 1.041.466 1.041 1.042h1.667a2.708 2.708 0 00-2.708-2.709v1.667z",
    fill: "#332C4A"
  })));
};

export default SvgAutoLockout;